import { render, staticRenderFns } from "./OctArticleHeader.vue?vue&type=template&id=af8c6d68&scoped=true&"
import script from "./OctArticleHeader.vue?vue&type=script&lang=js&"
export * from "./OctArticleHeader.vue?vue&type=script&lang=js&"
import style0 from "./OctArticleHeader.vue?vue&type=style&index=0&id=af8c6d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c6d68",
  null
  
)

export default component.exports